/* ============================================================
   EMIR — JavaScript global du thème
   ============================================================ */

(function() {
  'use strict';

  const shop = window.EmirTheme || {};

  // ============================================================
  // MENU MOBILE
  // ============================================================
  function initMobileMenu() {
    const toggle = document.querySelector('[data-menu-toggle]');
    const menu = document.querySelector('[data-mobile-menu]');
    if (!toggle || !menu) return;

    toggle.addEventListener('click', () => {
      const isOpen = menu.classList.contains('is-open');
      menu.classList.toggle('is-open', !isOpen);
      toggle.setAttribute('aria-expanded', !isOpen);
      document.body.style.overflow = !isOpen ? 'hidden' : '';
    });
  }

  // ============================================================
  // RECHERCHE OVERLAY
  // ============================================================
  function initSearch() {
    const toggle = document.querySelector('[data-search-toggle]');
    const overlay = document.querySelector('[data-search-overlay]');
    const closeBtn = document.querySelector('[data-search-close]');

    if (!overlay) return;

    const open = () => {
      overlay.classList.add('is-open');
      setTimeout(() => overlay.querySelector('input')?.focus(), 100);
    };
    const close = () => overlay.classList.remove('is-open');

    if (toggle) toggle.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);

    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) close();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
    });
  }

  // ============================================================
  // CART DRAWER
  // ============================================================
  const CartDrawer = {
    element: null,
    init() {
      this.element = document.querySelector('[data-cart-drawer]');
      if (!this.element) return;

      // Ouverture
      document.querySelectorAll('[data-cart-toggle]').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.open();
        });
      });

      // Fermeture
      this.element.querySelectorAll('[data-cart-close]').forEach(btn => {
        btn.addEventListener('click', () => this.close());
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) this.close();
      });

      // Actualisation au add-to-cart bundle
      document.addEventListener('cart:updated', () => this.refresh());
      document.addEventListener('cart:refresh', () => this.refresh());

      // Actions quantité et suppression
      this.element.addEventListener('click', (e) => this.handleAction(e));
    },
    isOpen() { return this.element?.classList.contains('is-open'); },
    open() {
      if (!this.element) return;
      this.refresh();
      this.element.classList.add('is-open');
      this.element.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    },
    close() {
      if (!this.element) return;
      this.element.classList.remove('is-open');
      this.element.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    },
    async handleAction(e) {
      const qtyBtn = e.target.closest('.cart-item__qty button');
      if (qtyBtn) {
        e.preventDefault();
        const lineKey = qtyBtn.dataset.lineKey;
        const action = qtyBtn.dataset.action;
        const current = parseInt(qtyBtn.parentElement.querySelector('span').textContent) || 1;
        const newQty = action === 'increase' ? current + 1 : Math.max(0, current - 1);
        await this.updateItem(lineKey, newQty);
        return;
      }

      const removeBtn = e.target.closest('[data-line-remove]');
      if (removeBtn) {
        e.preventDefault();
        await this.updateItem(removeBtn.dataset.lineRemove, 0);
        return;
      }

      const bundleRemoveBtn = e.target.closest('[data-bundle-remove]');
      if (bundleRemoveBtn) {
        e.preventDefault();
        if (confirm('Retirer toutes les pièces de cette tenue ?')) {
          await this.removeBundle(bundleRemoveBtn.dataset.bundleRemove);
        }
      }
    },
    async updateItem(lineKey, quantity) {
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: lineKey, quantity })
        });
        if (!res.ok) throw new Error('update failed');
        await this.refresh();
      } catch (e) {
        console.error('[Cart] update failed:', e);
      }
    },
    async removeBundle(bundleId) {
      try {
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        const updates = {};
        cart.items.forEach(item => {
          if (item.properties && item.properties._bundle_id === bundleId) {
            updates[item.key] = 0;
          }
        });
        if (Object.keys(updates).length === 0) return;
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
        await this.refresh();
      } catch (e) {
        console.error('[Cart] bundle remove failed:', e);
      }
    },
    async refresh() {
      try {
        // On récupère le nouveau HTML du drawer
        const res = await fetch(window.location.pathname + '?sections=cart-drawer-refresh');
        // Fallback : recharger la page si pas de section route
        if (!res.ok) {
          this.updateCountOnly();
          return;
        }
      } catch (e) {}

      // Simplement recharger les data et le compteur
      this.updateCountOnly();

      // Optionnel : recharger complètement le drawer via reload
      const bodyEl = this.element.querySelector('[data-cart-body]');
      const footerEl = this.element.querySelector('[data-cart-footer]');
      if (bodyEl) {
        try {
          const res = await fetch(window.location.pathname);
          const html = await res.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newBody = doc.querySelector('[data-cart-body]');
          const newFooter = doc.querySelector('[data-cart-footer]');
          if (newBody) bodyEl.innerHTML = newBody.innerHTML;
          if (newFooter && footerEl) footerEl.innerHTML = newFooter.innerHTML;
        } catch (e) {
          console.warn('[Cart] refresh HTML failed, falling back to reload');
          window.location.reload();
        }
      }
    },
    async updateCountOnly() {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        document.querySelectorAll('[data-cart-count]').forEach(el => {
          el.textContent = cart.item_count;
          el.dataset.cartCount = cart.item_count;
        });
      } catch (e) {}
    }
  };

  // ============================================================
  // REVEAL ON SCROLL
  // ============================================================
  //
  // CORRECTIF — les articles longs restaient blancs.
  //
  // Le seuil était à 0.05 : la section devait être visible à 5 % pour
  // recevoir `is-visible`. Or le ratio d'intersection maximum vaut
  // hauteur_fenêtre / hauteur_élément. Sur un article de 24 919 px dans
  // une fenêtre de 927 px, ça plafonne à 3,7 % — le seuil n'était donc
  // jamais atteint et l'opacité restait à 0.
  // Au-delà d'environ 18 500 px de hauteur, toute section devenait
  // invisible. D'où l'impression que ça touchait certains articles au
  // hasard : ce sont simplement les plus longs.
  //
  // `threshold: 0` déclenche dès qu'un pixel entre dans la fenêtre,
  // quelle que soit la hauteur. Le `rootMargin` de -12 % conserve
  // l'effet d'apparition progressive : l'animation part quand la section
  // a franchi le bas de l'écran, pas dès qu'elle affleure.
  // ============================================================
  function initReveal() {
    const els = document.querySelectorAll('.reveal, section');
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(e => e.classList.add('is-visible'));
      return;
    }

    const obs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          obs.unobserve(e.target);   // inutile de continuer à observer
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -12% 0px' });

    els.forEach(el => {
      el.classList.add('reveal');
      obs.observe(el);
    });

    // Filet de sécurité : si l'observateur n'a rien délivré au bout de
    // 1,5 s — onglet ouvert en arrière-plan, navigateur exotique — on
    // révèle ce qui se trouve déjà à l'écran. Le reste garde son
    // animation au défilement.
    setTimeout(() => {
      els.forEach(el => {
        if (el.classList.contains('is-visible')) return;
        const r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) {
          el.classList.add('is-visible');
        }
      });
    }, 1500);
  }

  // ============================================================
  // TABS
  // ============================================================
  function initTabs() {
    document.querySelectorAll('[data-tabs]').forEach(container => {
      const tabs = container.querySelectorAll('[data-tab]');
      const panels = container.querySelectorAll('[data-tab-panel]');

      tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          const target = tab.dataset.tab;
          tabs.forEach(t => t.classList.remove('is-active'));
          panels.forEach(p => p.classList.remove('is-active'));
          tab.classList.add('is-active');
          const panel = container.querySelector(`[data-tab-panel="${target}"]`);
          if (panel) panel.classList.add('is-active');
        });
      });
    });
  }

  // ============================================================
  // ACCORDIONS (déjà géré par <details>)
  // ============================================================

  // ============================================================
  // NEWSLETTER SUCCESS/ERROR (simple)
  // ============================================================
  function initNewsletter() {
    document.querySelectorAll('form[action*="/contact"]').forEach(form => {
      // Shopify gère nativement via {% form 'customer' %}
    });
  }

  // ============================================================
  // INTERCEPTION add-to-cart via forms (pour ouvrir drawer)
  // ============================================================
  function initAddToCart() {
    document.addEventListener('submit', async (e) => {
      const form = e.target;
      if (form.matches('form[action*="/cart/add"]')) {
        e.preventDefault();
        const submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.classList.add('is-loading');
        }

        try {
          const formData = new FormData(form);
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: formData
          });

          if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(err.description || 'Erreur ajout panier');
          }

          const data = await res.json();
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
          CartDrawer.open();
        } catch (err) {
          console.error('[AddToCart]', err);
          alert(err.message || 'Une erreur est survenue');
        } finally {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.classList.remove('is-loading');
          }
        }
      }
    });
  }

  // ============================================================
  // INIT
  // ============================================================
  function init() {
    initMobileMenu();
    initSearch();
    CartDrawer.init();
    initReveal();
    initTabs();
    initNewsletter();
    initAddToCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose
  window.EmirCart = CartDrawer;

})();

// Judge.me : libelles lecteurs d'ecran restes en anglais
(function(){var M={'sort reviews by':'Trier les avis par','filter reviews by':'Filtrer les avis par','search reviews':'Rechercher dans les avis'};function f(){document.querySelectorAll('.jdgm-visually-hidden, .jm-visually-hidden').forEach(function(el){var k=(el.textContent||'').trim().toLowerCase();if(M[k])el.textContent=M[k];});}document.addEventListener('DOMContentLoaded',f);setTimeout(f,2500);setTimeout(f,6000);})();

// Fiche detaillee : mise en forme auto du texte enrichi (lignes MAJUSCULES = titres)
(function(){function fmt(){try{var root=document.querySelector('.emir-panel__rte');if(!root||root.getAttribute('data-emir-fmt'))return;root.setAttribute('data-emir-fmt','1');var box=root.querySelector('.metafield-rich_text_field')||root;[].slice.call(box.querySelectorAll('p')).forEach(function(p){if(!p.querySelector('br'))return;var parts=p.innerHTML.split(/(?:\s*<br\s*\/?>\s*)+/i).map(function(s){return s.trim();}).filter(function(s){return s.length>0;});if(parts.length<2)return;var frag=document.createDocumentFragment();parts.forEach(function(h){var t=h.replace(/<[^>]*>/g,'').replace(/&nbsp;/g,' ').trim();var isT=t.length>1&&t.length<=48&&t===t.toUpperCase()&&/[A-ZÀ-Ý]/.test(t)&&!/[.:;!?,]$/.test(t);var el=document.createElement(isT?'h4':'p');el.innerHTML=h;frag.appendChild(el);});p.parentNode.replaceChild(frag,p);});}catch(e){}}document.addEventListener('DOMContentLoaded',fmt);setTimeout(fmt,1200);})();
// Masque les \n litteraux restes dans certaines descriptions importees de WordPress
(function(){function C(){try{document.querySelectorAll('.emir-panel__rte,.mp__short-desc,.story__block-text,.story__hero-text,.eqv-desc').forEach(function(r){var w=document.createTreeWalker(r,NodeFilter.SHOW_TEXT,null),L=[],n;while(n=w.nextNode()){if(n.nodeValue.indexOf('\\n')>-1)L.push(n);}L.forEach(function(t){var p=t.nodeValue.split('\\n');if(p.length<2)return;var f=document.createDocumentFragment();p.forEach(function(s,i){if(i>0){var b=p.slice(0,i).join('').replace(/\s/g,''),a=p.slice(i).join('').replace(/\s/g,'');if(b&&a)f.appendChild(document.createElement('br'));}f.appendChild(document.createTextNode(s));});t.parentNode.replaceChild(f,t);});});}catch(e){}}document.addEventListener('DOMContentLoaded',C);setTimeout(C,1200);})();

/* Pastilles de couleur des cartes produit : change la photo et ouvre le produit dans la couleur choisie */
(function () {
  function choose(sw) {
    var card = sw.closest('.product-card, .ebc__link');
    if (!card) return;
    var img = card.querySelector('.product-card__img--primary, .ebc__img');
    if (img && sw.dataset.img) {
      img.src = sw.dataset.img;
      if (sw.dataset.srcset) img.srcset = sw.dataset.srcset;
      if (sw.dataset.alt) img.alt = sw.dataset.alt;
    }
    if (sw.dataset.url) card.setAttribute('href', sw.dataset.url);
    card.classList.add('is-swatched');
    card.querySelectorAll('.product-card__swatch').forEach(function (s) { s.classList.toggle('is-active', s === sw); });
  }
  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('.product-card__swatch');
    if (!sw) return;
    e.preventDefault();
    e.stopPropagation();
    choose(sw);
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var sw = e.target.closest && e.target.closest('.product-card__swatch');
    if (!sw) return;
    e.preventDefault();
    choose(sw);
  });
})();
